export const hasAccess = (user, role) => {
  if (!user || !user.role || !role) {
    return false;
  }

  return hasRole(user.role).indexOf(String(role).toLowerCase()) > -1;
};

export const hasRole = (role) => {
  const normalizedRole = String(role || '').toLowerCase();

  switch (normalizedRole) {
    case 'superuser':
      return ['superuser', 'admin', 'scorer', 'user'];
    case 'admin':
      return ['admin', 'scorer', 'user'];
    case 'scorer':
      return ['scorer', 'user'];
    case 'user':
      return ['user'];
    default:
      return [];
  }
};

export const Roles = {
  SUPERUSER: 'superuser',
  ADMIN: 'admin',
  SCORER: 'scorer',
  USER: 'user'
};

const ROLE_RANK = {
  superuser: 4,
  admin: 3,
  scorer: 2,
  user: 1
};

export const getEffectiveRole = (user, workspace) => {
  const systemRole = String(user?.role || 'user').trim().toLowerCase();
  const memberRole = String(
    workspace?.members?.find((member) => member.id === user?.id)?.role || ''
  ).trim().toLowerCase();
  const systemRank = ROLE_RANK[systemRole] || 1;
  const workspaceRank = memberRole === 'admin' ? 3 : memberRole === 'user' ? 1 : 0;
  return workspaceRank > systemRank ? memberRole : systemRole;
};

export const hasWorkspaceAccess = (user, workspace, role) => {
  return hasRole(getEffectiveRole(user, workspace)).indexOf(String(role).toLowerCase()) > -1;
};
